/* eslint react/prop-types: 0 */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import FullDetailsAccordion from '../../../components/FullDetailsAccordion';
import { useFetchFieldData } from '../../../hooks/use-fetch-field-data';
import TabDetails from '../TabDetails';
import { ENTITY_OBJECT_TYPES } from '../../../shared/constants/entity.constants';

/**
 * TODO: add types definitions
 * @param {{
 * layout: any;
 * peopleData: any;
 * showLoader: VoidFunction;
 * }} props
 */
const PeopleTab = ({ peopleData, layout, showLoader }) => {
  const { id: tabId } = useParams();
  const [selectedId, setSelectedId] = useState('');
  const {
    entityCards: fieldsData,
    selectEntity,
    setEntityLayout,
    updateEntityValues
  } = useFetchFieldData(tabId);

  useEffect(() => {
    setEntityLayout(layout);
  }, [layout, setEntityLayout]);

  const selectCallback = (id) => {
    selectEntity(id);
    setSelectedId(id);
  };

  if (!Array.isArray(peopleData)) {
    return;
  }

  return peopleData.filter(Boolean).map((item) => (
    <FullDetailsAccordion
      key={item.id}
      id="people-tab"
      detailsComponent={
        <TabDetails
          fieldsData={fieldsData}
          tabId={tabId}
          selectedId={item.id}
          showLoader={showLoader}
          objectType={ENTITY_OBJECT_TYPES.PEOPLE}
          onValuesSaved={updateEntityValues}
        />
      }
      selectCallback={selectCallback}
      expanded={selectedId === item.id}
      {...item}
    >
      <>
        <span className="title">
          {item.first_name} {item.last_name}{' '}
          {item.job_title_name ? `(${item.job_title_name})` : ''}
        </span>
        <br />
        <span className="subtitle">{item.email}</span>
      </>
    </FullDetailsAccordion>
  ));
};

export default PeopleTab;
